'use client'
import { clsx } from 'clsx'
import React from 'react'

import AGallerySlide from './components/a-gallery-slide'
import { ISwiperConfig } from './components/gallery.types'

interface IZSectionGalleryProps {
	slug: string
	title?: string
	swiperConfig?: ISwiperConfig
	className?: string
}

const ZSectionGallery: React.FC<IZSectionGalleryProps> = ({
	title,
	swiperConfig = {},
	className = ''
}) => {
	// TODO: Uncomment after gallery API is ready
	// const { data, isLoading, error } = useGetSpacesBySlug(slug)
	// if (isLoading) return <div>Loading gallery...</div>
	// if (error) return <div>Error loading gallery</div>
	// if (!data?.images || data.images.length === 0) {
	//   console.warn('ZSectionGallery: no images found for slug:', slug)
	//   return null
	// }

	// Mock dáta - odstrániť po implementácii API
	const mockImages = [
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-1.avif`,
			uuid: '1',
			caption: 'Poliklinika Medante priestory 1'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-2.avif`,
			uuid: '2',
			caption: 'Poliklinika Medante priestory 2'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-3.avif`,
			uuid: '3',
			caption: 'Poliklinika Medante priestory 3'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-4.avif`,
			uuid: '4',
			caption: 'Poliklinika Medante priestory 4'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-5.avif`,
			uuid: '5',
			caption: 'Poliklinika Medante priestory 5'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-6.avif`,
			uuid: '6',
			caption: 'Poliklinika Medante priestory 6'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-7.avif`,
			uuid: '7',
			caption: 'Poliklinika Medante priestory 7'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-8.avif`,
			uuid: '8',
			caption: 'Poliklinika Medante priestory 8'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-9.avif`,
			uuid: '9',
			caption: 'Poliklinika Medante priestory 9'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-10.avif`,
			uuid: '10',
			caption: 'Poliklinika Medante priestory 10'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-11.avif`,
			uuid: '11',
			caption: 'Poliklinika Medante priestory 11'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-12.avif`,
			uuid: '12',
			caption: 'Poliklinika Medante priestory 12'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-13.avif`,
			uuid: '13',
			caption: 'Poliklinika Medante priestory 13'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-14.avif`,
			uuid: '14',
			caption: 'Poliklinika Medante priestory 14'
		},
		{
			url: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-15.avif`,
			uuid: '15',
			caption: 'Poliklinika Medante priestory 15'
		}
	]

	const data = { images: mockImages }

	const defaultSwiperConfig = {
		showArrows: true,
		showCounter: false,
		showProgressbar: false,
		spaceBetween: 60,
		slidesPerView: 'auto' as const,
		slidesPerGroup: 1,
		loop: false,
		breakpoints: {
			320: {
				slidesPerView: 'auto' as const,
				slidesPerGroup: 1,
				spaceBetween: 20
			},
			640: {
				slidesPerView: 'auto' as const,
				slidesPerGroup: 1,
				spaceBetween: 50
			},
			1026: {
				slidesPerView: 'auto' as const,
				slidesPerGroup: 1,
				spaceBetween: 60
			}
		}
	}

	const finalSwiperConfig = { ...defaultSwiperConfig, ...swiperConfig }

	return (
		<section className={clsx('pos_rel oh', className)} id='gallery'>
			<div className='cursordrag mgt-30 mgt-0lg'>
				<div className='swiper-gal'>
					<AGallerySlide
						images={data.images}
						title={title}
						swiperConfig={finalSwiperConfig}
					/>
				</div>
			</div>
		</section>
	)
}

export default ZSectionGallery
